import { API_ENDPOINTS } from "../../enums/apiUrls";
import { logError } from "../../utils/customLogger";
import { getBearerToken } from "./bearerToken";

interface GetAuthGridSourceRequest {
  order_id: string;
  signal: AbortSignal;
}

interface GetAuthGridSourceResponse {
  source?: string;
  updated_at?: string;
}

export const getAuthGridSource = async (
  payload: GetAuthGridSourceRequest,
): Promise<GetAuthGridSourceResponse> => {
  try {
    const token = await getBearerToken();

    if (!token) {
      throw new Error("Bearer token not available");
    }

    const response = await fetch(API_ENDPOINTS.GET_AUTH_GRID_SOURCE, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify({ order_id: payload.order_id }),
      signal: payload.signal,
    });

    if (!response.ok || response.status === 401 || response.status === 403) {
      throw new Error(`Failed to get auth grid source: ${response.statusText}`);
    }

    return response.json();
  } catch (error) {
    // Don't log AbortError as it's expected when request is cancelled
    if (error instanceof Error && error.name !== "AbortError") {
      logError(error, "Error in getAuthGridSource");
    }
    throw error;
  }
};
